module.exports = __webpack_public_path__ + "img/img2.9d1c51b2.png";